(function () {
  'use strict';

  function moneyFromCents(cents, format) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!format) return '$' + withComma;
    return String(format)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function cartUrl(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + path.replace(/^\//, '');
  }

  function formatCartMoney(cents, moneyFormat) {
    var formatted = moneyFromCents(cents, moneyFormat);
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
      if (currency && formatted.indexOf(currency) === -1) return formatted + ' ' + currency;
    } catch (e) {}
    return formatted;
  }

  function syncThemeTotals(totalCents, moneyFormat) {
    var text = formatCartMoney(totalCents, moneyFormat);
    [
      '.totals__subtotal-value',
      '.cart__total .price',
      '.cart-drawer__footer .totals__subtotal-value',
      '[data-cart-subtotal]',
      '.totals__total-value',
      'cart-drawer .totals__subtotal-value'
    ].forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
        if (!el || el.closest('[data-scg]')) return;
        el.textContent = text;
      });
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-scg-ready') === 'true') return;
    root.setAttribute('data-scg-ready', 'true');

    var limitsOn = root.getAttribute('data-limits-on') === 'true';
    if (!limitsOn) {
      root.hidden = true;
      return;
    }

    var useQty = root.getAttribute('data-use-qty') === 'true';
    var useSpend = root.getAttribute('data-use-spend') === 'true';
    var rulesMode = root.getAttribute('data-rules-mode') || 'either';
    var minQty = parseInt(root.getAttribute('data-min-qty') || '5', 10);
    var minSpend = parseInt(root.getAttribute('data-min-spend') || '6000', 10);
    var moneyFormat = root.getAttribute('data-money-format') || '$' + String.fromCharCode(123) + '{amount}}';
    var msgIncomplete =
      root.getAttribute('data-offer-incomplete') ||
      'Spend [remaining] more to get free shipping';
    var msgComplete =
      root.getAttribute('data-offer-complete') || "You've unlocked free shipping!";
    var celebrateOn = root.getAttribute('data-offer-celebrate') === 'true';
    var panel = root.querySelector('[data-scg-panel]');
    var msgEl = root.querySelector('[data-scg-msg]');
    var fillEl = root.querySelector('[data-scg-fill]');
    var barEl = root.querySelector('[data-scg-bar]');
    var burstEl = root.querySelector('[data-scg-burst]');
    var lastKey = '';
    var refreshTimer = null;
    var fetchBusy = false;
    var wasComplete = null;
    var celebrateIcons = ['🎉', '🎊', '✨', '🥳', '🎈'];
    var reduceCelebrate = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function meetsFreeShipping(qty, total) {
      if (!useQty && !useSpend) return true;
      var okQty = !useQty || qty >= minQty;
      var okSpend = !useSpend || total >= minSpend;
      if (useQty && useSpend) {
        return rulesMode === 'both' ? okQty && okSpend : okQty || okSpend;
      }
      return okQty && okSpend;
    }

    function progressOf(qty, total) {
      var spendP = 0;
      var qtyP = 0;
      var totalN = Math.max(0, Number(total) || 0);
      var qtyN = Math.max(0, Number(qty) || 0);

      if (minSpend > 0) spendP = Math.min(1, totalN / minSpend);
      if (minQty > 0) qtyP = Math.min(1, qtyN / minQty);

      if (useSpend && useQty) {
        return rulesMode === 'both' ? Math.min(spendP, qtyP) : Math.max(spendP, qtyP);
      }
      if (useSpend) return spendP;
      if (useQty) return qtyP;
      if (minSpend > 0) return spendP;
      return 0;
    }

    function fillTokens(template, qty, total) {
      var needSpend = Math.max(0, minSpend - total);
      var needQty = Math.max(0, minQty - qty);
      var parts = [];
      if (useQty) parts.push(minQty + '+ items');
      if (useSpend) parts.push(moneyFromCents(minSpend, moneyFormat) + '+');
      var rules =
        !parts.length ? '' : parts.length === 1 ? parts[0] : parts.join(rulesMode === 'both' ? ' and ' : ' or ');

      return String(template || '')
        .replace(/\[remaining\]/gi, moneyFromCents(needSpend, moneyFormat))
        .replace(/\[spent\]/gi, moneyFromCents(total, moneyFormat))
        .replace(/\[goal\]/gi, moneyFromCents(minSpend, moneyFormat))
        .replace(/\[amount\]/gi, moneyFromCents(minSpend, moneyFormat))
        .replace(/\[qty_remaining\]/gi, String(needQty))
        .replace(/\[qty_current\]/gi, String(qty))
        .replace(/\[qty_spent\]/gi, String(qty))
        .replace(/\[qty_goal\]/gi, String(minQty))
        .replace(/\[qty\]/gi, String(minQty))
        .replace(/\[rules\]/gi, rules)
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+\./g, '.')
        .trim();
    }

    function autoMessage(qty, total, freeShip) {
      if (freeShip) return fillTokens(msgComplete, qty, total);
      var custom = String(msgIncomplete || '');
      var hasNewTokens = /\[remaining\]|\[qty_remaining\]|\[spent\]|\[goal\]/i.test(custom);
      if (hasNewTokens) {
        return fillTokens(custom, qty, total);
      }
      var needSpend = Math.max(0, minSpend - total);
      var needQty = Math.max(0, minQty - qty);
      if (useSpend && useQty && rulesMode === 'both') {
        return (
          'Spend ' +
          moneyFromCents(needSpend, moneyFormat) +
          ' more and add ' +
          needQty +
          ' more item' +
          (needQty === 1 ? '' : 's') +
          ' to get free shipping'
        );
      }
      if (useSpend) {
        if (useQty && needSpend <= 0 && needQty > 0) {
          return 'Add ' + needQty + ' more item' + (needQty === 1 ? '' : 's') + ' to get free shipping';
        }
        return 'Spend ' + moneyFromCents(needSpend, moneyFormat) + ' more to get free shipping';
      }
      if (useQty) {
        return 'Add ' + needQty + ' more item' + (needQty === 1 ? '' : 's') + ' to get free shipping';
      }
      return fillTokens(custom, qty, total);
    }

    function fireCelebration() {
      if (!celebrateOn || reduceCelebrate || !burstEl) return;
      burstEl.innerHTML = '';
      for (var i = 0; i < 14; i++) {
        var bit = document.createElement('span');
        bit.className = 'scg__confetti';
        bit.textContent = celebrateIcons[i % celebrateIcons.length];
        bit.style.setProperty('--smp-cx', (Math.random() * 160 - 80).toFixed(1) + 'px');
        bit.style.setProperty('--smp-cy', (Math.random() * 40 - 10).toFixed(1) + 'px');
        bit.style.setProperty('--smp-rot', (Math.random() * 80 - 40).toFixed(1) + 'deg');
        bit.style.animationDelay = (Math.random() * 0.25).toFixed(2) + 's';
        bit.style.left = 20 + Math.random() * 60 + '%';
        burstEl.appendChild(bit);
      }
      window.setTimeout(function () {
        if (burstEl) burstEl.innerHTML = '';
      }, 1600);
    }

    function maybeCelebrate(freeShip) {
      if (wasComplete === null) {
        wasComplete = freeShip;
        return;
      }
      if (freeShip && !wasComplete) fireCelebration();
      wasComplete = freeShip;
    }

    function barColor(complete) {
      try {
        var key = complete ? '--scg-offer-bar-done' : '--scg-offer-bar';
        var raw = (window.getComputedStyle(root).getPropertyValue(key) || '').trim();
        if (raw) return raw;
      } catch (e) {}
      return '#cf1f25';
    }

    function applyState(qty, total) {
      syncThemeTotals(total, moneyFormat);

      var freeShip = meetsFreeShipping(qty, total);
      var progress =
        freeShip ? 1 : minSpend > 0 ? Math.min(1, Math.max(0, Number(total) / minSpend)) : progressOf(qty, total);
      var pct = Math.round(Math.min(1, Math.max(0, progress)) * 100);
      if (freeShip) pct = 100;
      var key = qty + ':' + total + ':' + pct + ':' + (freeShip ? 'f' : 'p');
      if (key === lastKey) return;
      lastKey = key;

      root.hidden = false;
      if (panel) panel.hidden = false;

      var color = barColor(freeShip);
      root.style.setProperty('--scg-offer-pct', pct + '%');
      root.style.setProperty('--scg-accent', color);
      if (barEl) {
        barEl.style.setProperty('--scg-offer-pct', pct + '%');
        barEl.style.setProperty('--scg-accent', color);
        barEl.setAttribute('data-pct', String(pct));
        barEl.setAttribute('aria-valuenow', String(pct));
        barEl.setAttribute(
          'aria-label',
          freeShip
            ? 'Free shipping unlocked'
            : 'Free shipping progress ' + pct + ' percent'
        );
      }
      if (fillEl) {
        fillEl.style.setProperty('width', pct + '%', 'important');
        fillEl.style.setProperty('background', color, 'important');
        fillEl.style.setProperty('background-color', color, 'important');
        fillEl.setAttribute('aria-valuenow', String(pct));
      }
      if (msgEl) msgEl.textContent = autoMessage(qty, total, freeShip);

      root.classList.toggle('scg--ok', freeShip);
      root.classList.toggle('scg--warn', !freeShip);
      maybeCelebrate(freeShip);
    }

    function refresh() {
      if (fetchBusy) {
        scheduleRefresh(500);
        return;
      }
      fetchBusy = true;
      var fallbackQty = parseInt(root.getAttribute('data-item-count') || '0', 10);
      var fallbackTotal = parseInt(root.getAttribute('data-total-price') || '0', 10);

      fetch(cartUrl('cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var qty = cart.item_count || 0;
          var total = cart.total_price || 0;
          root.setAttribute('data-item-count', String(qty));
          root.setAttribute('data-total-price', String(total));
          applyState(qty, total);
        })
        .catch(function () {
          applyState(fallbackQty, fallbackTotal);
        })
        .finally(function () {
          fetchBusy = false;
        });
    }

    function scheduleRefresh(delay) {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refresh, typeof delay === 'number' ? delay : 600);
    }

    root.__scgRefresh = function () {
      lastKey = '';
      scheduleRefresh(150);
    };

    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t || !t.closest) return;
      if (
        t.closest('.quantity__button') ||
        t.closest('quantity-input') ||
        t.closest('cart-remove-button') ||
        t.closest('[name="updates[]"]')
      ) {
        scheduleRefresh(1100);
      }
    });

    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t) return;
      if (t.name === 'updates[]' || (t.classList && t.classList.contains('quantity__input'))) {
        scheduleRefresh(1100);
      }
    });

    ['cart:updated', 'cart:change', 'theme:cart:change'].forEach(function (name) {
      document.addEventListener(name, function () {
        scheduleRefresh(400);
      });
    });

    root._scgPoll = window.setInterval(function () {
      if (document.hidden) return;
      refresh();
    }, 2500);

    refresh();
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-scg]'), function (el) {
      try {
        init(el);
      } catch (err) {
        if (typeof console !== 'undefined' && console.error) console.error(err);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target || !event.target.querySelector) return;
    var el = event.target.querySelector('[data-scg]');
    if (el) {
      el.removeAttribute('data-scg-ready');
      init(el);
    }
  });

  window.SewpheeCartShipping = {
    boot: boot,
    refreshAll: function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-scg]'), function (el) {
        if (typeof el.__scgRefresh === 'function') el.__scgRefresh();
      });
    }
  };
})();
